import { render } from "./6-IndustryInfo.vue?vue&type=template&id=32a2a59c"
import script from "./6-IndustryInfo.vue?vue&type=script&lang=js"
export * from "./6-IndustryInfo.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./6-IndustryInfo.vue?vue&type=style&index=0&id=32a2a59c&lang=less&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__